import React from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
} from "@material-ui/core";
import FileUpload from "../../components/FileUpload/FileUpload";
import FileList from "../../components/FileList/FileList";
import { client } from "../../service/ApolloClient/ApolloClient";
import { QUERY_ATTACHMENTS } from "../../service/ApolloClient/ApolloQueries";
import { ErrorToast } from "../../hoc/ToastNotify/ToastNotify";

class FilePage extends React.Component {
  constructor() {
    super();

    this.state = {
      files: [],
    };

    this.handleReload = this.handleReload.bind(this);
  }

  componentDidMount() {
    this.handleReload();
  }

  handleReload = () => {
    client
      .query({
        query: QUERY_ATTACHMENTS,
        variables: {
          page: 1,
          limit: 100,
          table: this.props.table,
          table_id: this.props.id,
        },
        fetchPolicy: "network-only",
      })
      .then((res) => {
        let attachs = res.data.attachments.data;
        this.setState({
          files: attachs,
        });
      })
      .catch((err) => {
        ErrorToast("مشکل در دریافت اطلاعات");
      });
  };

  render() {
    const { title, id, table } = this.props;
    const { files } = this.state;

    return (
      <Wrapper>
        <Box pb={1}>
          <Card>
            <CardContent>
              <Box display={"flex"} style={{ width: "100%" }}>
                <Box textAlign={"left"} fullWidth={true}>
                  <Typography variant={"h6"}>{title}</Typography>
                </Box>
                <Box flexGrow={1} textAlign={"right"}>
                  <Button
                    onClick={this.props.handleBack}
                    size={"small"}
                    variant={"contained"}
                  >
                    برگشت
                  </Button>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Box>
        <Card>
          <CardContent>
            <Grid container={true}>
              <Grid item xs={12}>
                <FileUpload
                  id={id}
                  table={table}
                  handleReload={this.handleReload}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <Box pt={1}>
          <Card>
            <CardContent>
              <FileList files={files} handleReload={this.handleReload} />
            </CardContent>
          </Card>
        </Box>
      </Wrapper>
    );
  }
}

export default FilePage;
